// extracted by mini-css-extract-plugin
export default {"countdown":"CountDown_countdown__eORpu","countdownDis":"CountDown_countdownDis__NzsRJ","countNum":"CountDown_countNum__62Lzb"};